import * as React from 'react';
import './App.css';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AppProvider from './_context/App';
// import Tracker from './Components/Tracker/Tracker';
import { ClassNames } from './_helpers/ClassNames';
import Page from './Components/Page/Page';
import Menu from './Components/Menu/Menu';

class App extends React.Component {

  public render() {
    return (
      <Router>
        <AppProvider>

          <div className={ClassNames('app', '')} >
            <Menu />
            <Switch>
              <Route
                component={Page}
              />
            </Switch>
          </div>
        </AppProvider>
      </Router>
    );
  }
}

// <AppProvider.Consumer>
//             {(ctx) => ctx.app && <Tracker trackingCode={ctx.app.GoogleAnalyticsCode} />}
//           </AppProvider.Consumer>

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx